/** Drag data of a board tile on the workspace page. */
export const boardTileData = (workspaceId: string, boardId: string) => ({
  type: 'board-tile',
  workspaceId,
  boardId,
});

export function isBoardTile(
  data: Record<string | symbol, unknown>,
): data is Record<string | symbol, unknown> & ReturnType<typeof boardTileData> {
  return (
    data.type === 'board-tile' &&
    typeof data.workspaceId === 'string' &&
    typeof data.boardId === 'string'
  );
}
